export default {"src":"/_next/static/media/twitter-icon.c266cceb.svg","height":96,"width":118};